// @module SuiteDB.SDBProductMapPairs.SDBProductMapPairs
define("SuiteDB.SDBProductMapPairs.View", [
  "suitedb_sdbproductmappairs.tpl",
  "SuiteDB.SDBProductMapPairs.SS2Model",
  "Backbone",
], function (
  suitedbsdbproductmappairs_tpl,
  SDBProductMapPairsSS2Model,
  Backbone
) {
  "use strict";

  return Backbone.View.extend({
    template: suitedbsdbproductmappairs_tpl,
    initialize: function initialize(options) {
      var self = this;
      var pdp = SC.Application.getComponent("PDP");
      var item = pdp.getItemInfo().item;
      var itemRecordType = item.itemtype;
      if (!itemRecordType || itemRecordType.toLowerCase() != "invtpart") return;

      var vehicleConfig = this.getCookie("vehicleConfig");
      self.vehicleYMM = this.getCookie("vehicle");
      if (self.vehicleYMM) {
        self.vehicleYMM = JSON.parse(self.vehicleYMM);
        self.vehicleYMM =
          self.vehicleYMM.year +
          " " +
          self.vehicleYMM.make +
          " " +
          self.vehicleYMM.model;
      }
      self.isTire = !!(item.class.toUpperCase().indexOf("TIRES") === 0);
      this.model = new SDBProductMapPairsSS2Model();
      var tireId = "";
      var wheelId = "";
      if (self.isTire) tireId = item.custitemrs_fitment_id;
      else wheelId = item.custitemrs_fitment_id;

      this.isRear = false;
      this.isFront = false;
      this.model
        .fetch({
          async: true,
          cache: true,
          data: {
            tireFitmentID: tireId,
            vehicleConfigID: vehicleConfig,
            wheelFitmentID: wheelId,
            manufacturer: item.custitemrs_brand,
            modelID: item.custitemrs_model,
          },
        })
        .done(function (result) {
          var sortedResults = self.sortItems(JSON.parse(result));
          self.isRear = sortedResults.rear.length > 0;
          self.isFront = sortedResults.front.length > 0;
          self.result = sortedResults;
          self.render();
        });
    },

    getContext: function getContext() {
      var notStaggered = !(this.result && (this.isRear || this.isFront));

      return {
        isRear: this.isRear,
        isFront: this.isFront,
        isBoth: this.isRear && this.isFront,
        isTire: this.isTire,
        notStaggered: notStaggered,
        frontOptions: this.result ? this.result.front : [],
        rearOptions: this.result ? this.result.rear : [],
        vehicle: this.vehicleYMM,
      };
    },

    getCookie: function getCookie(name) {
      var cookieOptions = document.cookie.split(";");
      var vehicleCookie = _.filter(cookieOptions, function (cookie) {
        return cookie.split("=")[0].trim() == name;
      });
      if (vehicleCookie.length > 0) {
        return vehicleCookie[0].match(/=(.*)$/)[1];
      }
    },

    sortItems: function sortItems(result) {
      var rear = [];
      var front = [];
      for (var i = 0; i < result.length; i++) {
        var item = result[i];
        if (item.rearOrFront == "REAR") rear.push(item);
        else if (item.rearOrFront == "FRONT") front.push(item);
      }

      return { rear: rear, front: front };
    },
  });
});
